@if (!minimalView) {
    <div [matTooltip]="additionalHoverInformation" class="c-pill--display">{{ displayPillText }}</div>
}
@if (minimalView) {
    <div [matTooltip]="additionalHoverInformation" class="c-pill--display-minimal"></div>
}